<div class="instructions-list">
    @if (!loading) {
        <div class="download-button">
            <button mat-stroked-button
                (click)="downloadXmlFile()">{{'default.downloadAsXml' | blah}}</button>
        </div>
        @for (instruction of instructions; track instruction) {
            <div class="instruction">
                <a href="{{instruction.url}}">{{instruction.name}}</a>
            </div>
        }
    } @else {
        <hpo-placeholder type="row"></hpo-placeholder>
    }
</div>